import * as React from 'react';
import { LinkedInEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var Linkedin = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(LinkedInEmbed, { url: link, width: "100%" })));
};
